import { createContext } from 'react';

import type { AnalyticsInterface } from './services';

export const AnalyticsContext = createContext<AnalyticsInterface | undefined>(undefined);
